// src/services/HomePageContentService.js
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../utils/axiosBaseQuery"; // Assuming the same custom axiosBaseQuery is used
import { HOME_PAGE_DETAILS, HOME_PAGE_UPDATE } from "../../config/constants"; // Adjust endpoints as per your config

const HomePageContentService = createApi({
  reducerPath: "HomePageContentService",
  baseQuery: axiosBaseQuery({ baseUrl: "" }), // Use axiosBaseQuery
  tagTypes: ["HomePage"],
  endpoints: (builder) => ({
    getHomePageDetails: builder.query({
      query: (bodyData) => ({
        url: HOME_PAGE_DETAILS, // Endpoint to fetch settings list
        data: bodyData, // Pass the body data for the request
      }),
      providesTags: ["HomePage"],
    }),
    updateHomePage: builder.mutation({
      query: ({ updatedData }) => ({
        url: `${HOME_PAGE_UPDATE}`, // Endpoint to update a settings
        method: "PUT",
        data: updatedData, // Updated settings data
      }),
      invalidatesTags: ["HomePage"],
    }),
  }),
});

// Export hooks for usage in functional components
export const { useGetHomePageDetailsQuery, useUpdateHomePageMutation } =
  HomePageContentService;

// Export the reducer to be included in the store
export default HomePageContentService;
